module.exports = __webpack_public_path__ + "img/step3.3b9abe0b.png";